<template>
    <div class="portal__auth" @keyup.enter="tryLogin" tabindex="0">
        <div class="portal__auth__bg"></div>
        <div class="portal__auth__content">
            <div class="portal__auth__form__auth">
                <button @click="tryLogin" class="btn btn-primary portal__auth__form__auth__submit">
                    <span v-if="!isLoading">Войти</span>
                    <Loader v-else class="pos-rel" />
                </button>
            </div>
            <input v-if="testMode" v-model="login" />
            <input v-if="testMode" v-model="pass" />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue';
import Loader from '@/components/layout/Loader.vue';
import { useRoute, useRouter } from 'vue-router';
import { testMode } from '@/assets/static/testMode';
import Api from '@/utils/Api';
import { useUserData } from '@/stores/userData';
import Cookies from 'js-cookie';

export default defineComponent({
    name: 'AuthPage',
    components: {
        Loader
    },
    setup() {
        const router = useRouter();
        const route = useRoute();
        const isLoading = ref(false);
        const login = ref(import.meta.env.VITE_LOGIN);
        const pass = ref(import.meta.env.VITE_PASSWORD);
        const userData = useUserData();

        const tryLogin = () => {
            isLoading.value = true;
            if (testMode) {
                testLogin();
            }
            else {
                const referrer = import.meta.env.VITE_API_URL.replace('/api', '') + route.fullPath.replace('/?reroute=', '');
                router.push({ name: 'oauthPage', params: { referrer: referrer } });
            }
            isLoading.value = false;
        }

        const testLogin = async () => {
            const data: { session_id: string } = await Api.post("auth_router/root_auth", { login: login.value, password: pass.value })
            userData.initLogin(data.session_id, 2366);
            userData.setLogin(true);
        }

        watch((route), () => {
            if (!userData.getIsLogin && route.fullPath) {
                if (route.name !== 'oauthPage') {
                    Cookies.set('referrer', String(route.fullPath).replace('/?reroute=https://intranet.emk.ru', ''), { expires: 365 });
                }
            }
        }, { immediate: true, deep: true })

        return {
            login,
            pass,
            isLoading,
            testMode,
            tryLogin
        };
    },
})
</script>
